(() => {
  const variants = [{"id":"67791322546478","style":"Dewdrop","size":"XS","tier":1},{"id":"67791322579246","style":"Dewdrop","size":"S","tier":1},{"id":"67791322612014","style":"Dewdrop","size":"M","tier":1},{"id":"67791322644782","style":"Dewdrop","size":"L","tier":1},{"id":"67791322677550","style":"Dewdrop","size":"XL","tier":1},{"id":"67791322710318","style":"Twilight","size":"XS","tier":1},{"id":"67791322743086","style":"Twilight","size":"S","tier":1},{"id":"67791322775854","style":"Twilight","size":"M","tier":1},{"id":"67791322808622","style":"Twilight","size":"L","tier":1},{"id":"67791322841390","style":"Twilight","size":"XL","tier":1},{"id":"67791322874158","style":"Moonshadow","size":"XS","tier":1},{"id":"67791322906926","style":"Moonshadow","size":"S","tier":1},{"id":"67791322939694","style":"Moonshadow","size":"M","tier":1},{"id":"67791322972462","style":"Moonshadow","size":"L","tier":1},{"id":"67791323005230","style":"Moonshadow","size":"XL","tier":1},{"id":"67791323037998","style":"Dewdrop","size":"XS","tier":2},{"id":"67791323070766","style":"Dewdrop","size":"S","tier":2},{"id":"67791323103534","style":"Dewdrop","size":"M","tier":2},{"id":"67791323136302","style":"Dewdrop","size":"L","tier":2},{"id":"67791323169070","style":"Dewdrop","size":"XL","tier":2},{"id":"67791323201838","style":"Twilight","size":"XS","tier":2},{"id":"67791323234606","style":"Twilight","size":"S","tier":2},{"id":"67791323267374","style":"Twilight","size":"M","tier":2},{"id":"67791323300142","style":"Twilight","size":"L","tier":2},{"id":"67791323332910","style":"Twilight","size":"XL","tier":2},{"id":"67791323365678","style":"Moonshadow","size":"XS","tier":2},{"id":"67791323398446","style":"Moonshadow","size":"S","tier":2},{"id":"67791323431214","style":"Moonshadow","size":"M","tier":2},{"id":"67791323463982","style":"Moonshadow","size":"L","tier":2},{"id":"67791323496750","style":"Moonshadow","size":"XL","tier":2},{"id":"67791323529518","style":"Dewdrop","size":"XS","tier":3},{"id":"67791323562286","style":"Dewdrop","size":"S","tier":3},{"id":"67791323595054","style":"Dewdrop","size":"M","tier":3},{"id":"67791323627822","style":"Dewdrop","size":"L","tier":3},{"id":"67791323660590","style":"Dewdrop","size":"XL","tier":3},{"id":"67791323693358","style":"Twilight","size":"XS","tier":3},{"id":"67791323726126","style":"Twilight","size":"S","tier":3},{"id":"67791323758894","style":"Twilight","size":"M","tier":3},{"id":"67791323791662","style":"Twilight","size":"L","tier":3},{"id":"67791323824430","style":"Twilight","size":"XL","tier":3},{"id":"67791323857198","style":"Moonshadow","size":"XS","tier":3},{"id":"67791323889966","style":"Moonshadow","size":"S","tier":3},{"id":"67791323922734","style":"Moonshadow","size":"M","tier":3},{"id":"67791323955502","style":"Moonshadow","size":"L","tier":3},{"id":"67791323988270","style":"Moonshadow","size":"XL","tier":3}];
  const byId = new Map(variants.map(v => [String(v.id),v]));
  const protectionId='67696184230190', giftId='67779704095022';
  const root=window.Shopify?.routes?.root||'/';
  let queue=Promise.resolve(), typingTimer, pendingInput, checkoutPending=false, cartError=false;
  const request=async(path,body)=>{
    const response=await fetch(root+path,body?{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}:{});
    const data=await response.json();
    if(!response.ok||data.status)throw new Error(data.description||'Unable to update your cart. Please try again.');
    return data;
  };
  const groups=cart=>{
    const result=new Map();
    cart.items.forEach(item=>{
      const variant=byId.get(String(item.variant_id));
      if(!variant)return;
      const key=variant.style+'|'+variant.size;
      result.set(key,(result.get(key)||0)+item.quantity);
    });
    return result;
  };
  const schedule=(work,status,opener)=>{
    if(status)status.textContent='Updating your cart…';
    if(opener)opener.setAttribute('aria-busy','true');
    queue=queue.catch(()=>{}).then(work).then(()=>{cartError=false;if(status)status.textContent='';}).catch(error=>{
      cartError=true;
      if(status)status.textContent=error.message;
      const visible=document.querySelector('cart-drawer.active [data-hh-drawer-status]');
      if(visible&&visible!==status)visible.textContent=error.message;
    }).finally(()=>{if(opener)opener.removeAttribute('aria-busy');});
    return queue;
  };
  const syncChoice=(key,selector,checked)=>{
    document.querySelectorAll(selector).forEach(input=>{input.checked=checked;});
    try{sessionStorage.setItem('pixie-'+key,String(checked));}catch{}
  };
  const normalize=async(cart,desired,protectionChoice,giftChoice,opener,keepClosed=false)=>{
    const count=Array.from(desired.values()).reduce((sum,n)=>sum+n,0);
    const tier=Math.min(Math.max(count,1),3);
    const wanted=new Map();
    desired.forEach((quantity,key)=>{
      if(quantity<=0)return;
      const [style,size]=key.split('|');
      const variant=variants.find(v=>v.style===style&&v.size===size&&v.tier===tier);
      if(!variant)throw new Error('That style and size could not be selected. Please try again.');
      wanted.set(String(variant.id),quantity);
    });
    const updates={}, retained=new Set();
    const protectionPresent=cart.items.some(item=>String(item.variant_id)===protectionId);
    const giftPresent=cart.items.some(item=>String(item.variant_id)===giftId);
    const protection=count>0&&(protectionChoice===null?protectionPresent:protectionChoice);
    const gift=count>0&&(giftChoice===null?giftPresent:giftChoice);
    cart.items.forEach(item=>{
      const id=String(item.variant_id);
      if(byId.has(id)){
        const amount=!retained.has(id)?wanted.get(id)||0:0;
        updates[item.key]=amount;if(amount)retained.add(id);
      }else if(id===protectionId||id===giftId){
        const keep=(id===protectionId?protection:gift)&&!retained.has(id);
        updates[item.key]=keep?1:0;if(keep)retained.add(id);
      }
    });
    wanted.forEach((quantity,id)=>{if(!retained.has(id))updates[id]=quantity;});
    if(protection&&!retained.has(protectionId))updates[protectionId]=1;
    if(gift&&!retained.has(giftId))updates[giftId]=1;
    const result=await request('cart/update.js',{updates,attributes:{pixie_priority_shipping:count>=2?'included':'',pixie_pricing:'units-v1'},sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname});
    const drawer=document.querySelector('cart-drawer');
    if(drawer&&typeof drawer.renderContents==='function'){
      drawer.classList.toggle('is-empty',result.item_count===0);
      drawer.renderContents({...result,id:Array.from(wanted.keys())[0]||protectionId},keepClosed);
      if(!keepClosed)drawer.open(opener);
    }else if(window.location.pathname.replace(/\/$/,'').endsWith('/cart'))window.location.reload();
    else if(!keepClosed)window.location.assign(root+'cart');
    return result;
  };
  const init=()=>{
    initVideos();
    schedule(async()=>{
      const cart=await request('cart.js');
      const desired=groups(cart);
      if(!desired.size)return;
      await normalize(cart,desired,null,null,null,true);
    },null,null);
  };
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement)||!form.closest('product-form'))return;
    const picker=form.closest('.product__info-container')?.querySelector('hh-offer-picker')||document.querySelector('hh-offer-picker');
    if(!picker||typeof picker.getSelections!=='function')return;
    event.preventDefault();event.stopImmediatePropagation();
    const choices=picker.getSelections().map(v=>({...v}));
    const protection=!!picker.querySelector('[data-hh-protection]:checked');
    const gift=!!picker.querySelector('[data-hh-mystery-gift]:checked');
    schedule(async()=>{
      const cart=await request('cart.js');const desired=groups(cart);
      choices.forEach(({style,size})=>{const key=style+'|'+size;desired.set(key,(desired.get(key)||0)+1);});
      await normalize(cart,desired,protection,gift,event.submitter);
    },picker.querySelector('[data-hh-cart-status]'),event.submitter);
  },true);
  const isQuantity=input=>input.matches('.cart-item--product-pixie-denim-fairyflare-jeans input[name="updates[]"]');
  const changeQuantity=input=>{
    const quantity=Number(input.value);
    if(!Number.isInteger(quantity)||quantity<0)return;
    const id=input.dataset.quantityVariantId||input.dataset.variantId;
    const variant=byId.get(String(id));
    if(!variant)return;
    schedule(async()=>{
      const cart=await request('cart.js');const desired=groups(cart);const key=variant.style+'|'+variant.size;
      if(quantity)desired.set(key,quantity);else desired.delete(key);
      await normalize(cart,desired,null,null,input);
    },document.querySelector('[data-hh-drawer-status]'),input);
  };
  document.addEventListener('change',event=>{
    if(!isQuantity(event.target))return;
    event.preventDefault();event.stopImmediatePropagation();clearTimeout(typingTimer);pendingInput=null;changeQuantity(event.target);
  },true);
  document.addEventListener('input',event=>{
    if(!isQuantity(event.target))return;
    clearTimeout(typingTimer);pendingInput=event.target;
    typingTimer=setTimeout(()=>{const input=pendingInput;pendingInput=null;if(input)changeQuantity(input);},300);
  },true);
  document.addEventListener('click',async event=>{
    const checkout=event.target.closest('#CartDrawer-Checkout');
    if(checkout){
      event.preventDefault();event.stopImmediatePropagation();
      if(checkoutPending)return;checkoutPending=true;
      if(pendingInput){clearTimeout(typingTimer);changeQuantity(pendingInput);pendingInput=null;}
      await queue;checkoutPending=false;
      if(!cartError)window.location.assign(root+'checkout');
      return;
    }
    const remove=event.target.closest('cart-remove-button button,cart-remove-button a');
    if(!remove)return;
    const row=remove.closest('.cart-item');
    if(!row)return;
    const isProtection=row.classList.contains('cart-item--product-shipping-protection');
    const isGift=row.classList.contains('cart-item--product-mystery-gift');
    const isHero=row.classList.contains('cart-item--product-pixie-denim-fairyflare-jeans');
    if(!isProtection&&!isGift&&!isHero)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(isProtection)syncChoice('protection','[data-hh-protection]',false);
    if(isGift)syncChoice('gift','[data-hh-mystery-gift]',false);
    const input=row.querySelector('input[name="updates[]"]');
    const id=input?.dataset.quantityVariantId||input?.dataset.variantId;
    const variant=byId.get(String(id));
    schedule(async()=>{
      const cart=await request('cart.js');const desired=groups(cart);
      if(isHero&&variant)desired.delete(variant.style+'|'+variant.size);
      await normalize(cart,desired,isProtection?false:null,isGift?false:null,remove);
    },document.querySelector('[data-hh-drawer-status]'),remove);
  },true);
  const initVideos=(scope=document)=>{
    scope.querySelectorAll('video[data-hh-autoplay]:not([data-hh-observed])').forEach(video=>{
      video.dataset.hhObserved='true';video.muted=true;video.loop=true;
      const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting)video.play().catch(()=>{video.controls=true;});else video.pause();});},{threshold:0.25});
      observer.observe(video);
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',event=>initVideos(event.target));
})();
